import React from 'react';


interface ServiceTier {
  id: number;
  name: string;
  description: string;
  priceIndicator: string;
  features: string[];
  highlighted: boolean;
  icon: string;
  bestFor: string;
}

interface ServiceTiersProps {
  className?: string;
}

const ServiceTiers = ({ className = '' }: ServiceTiersProps) => {
  const tiers: ServiceTier[] = [
  {
    id: 1,
    name: 'Essential',
    description: 'Perfect for single-product registrations and focused regulatory needs',
    priceIndicator: 'Project-based',
    features: [
    'Single product dossier preparation',
    'Country-specific regulatory guidance',
    'Documentation review & compilation',
    'Submission coordination',
    'Email support (48-hour response)',
    'Quarterly regulatory updates'],

    highlighted: false,
    icon: 'DocumentTextIcon',
    bestFor: 'Small manufacturers, single market entry'
  },
  {
    id: 2,
    name: 'Professional',
    description: 'Comprehensive support for multi-product portfolios and ongoing compliance',
    priceIndicator: 'Retainer-based',
    features: [
    'Multi-product portfolio management',
    'Dedicated regulatory consultant',
    'GMP compliance support',
    'Variation & renewal management',
    'Priority support (24-hour response)',
    'Monthly regulatory intelligence reports',
    'Quarterly compliance audits',
    'Training workshops (2 per year)'],

    highlighted: true,
    icon: 'ShieldCheckIcon',
    bestFor: 'Growing companies, multiple markets'
  },
  {
    id: 3,
    name: 'Enterprise',
    description: 'Strategic partnership for complex regulatory landscapes and global expansion',
    priceIndicator: 'Custom pricing',
    features: [
    'Full-service regulatory department',
    'Senior consultant team assignment',
    'Global market entry strategy',
    'Complete lifecycle management',
    'On-site audit support',
    '24/7 priority support',
    'Weekly intelligence briefings',
    'Unlimited training & workshops',
    'Regulatory technology platform access',
    'Executive regulatory advisory'],

    highlighted: false,
    icon: 'BuildingOfficeIcon',
    bestFor: 'Large enterprises, global operations'
  }];


  return;





































































































};

export default ServiceTiers;